export default __webpack_public_path__ + "static/media/arrowL.ef73f5cb.png";